import React, { useState, useEffect } from "react";
import './guideHero.css';
import logo from './matchededgeblue.png';
import logoWhite from './matchededgeallwhite.png';

const GuideHero = ({ title, level, icon }) => {
  // track theme in state
  const [isLightTheme, setIsLightTheme] = useState(
    () => document.documentElement.getAttribute("data-theme") === "light"
  );

  useEffect(() => {
    // helper to read the current attribute
    const checkTheme = () =>
      setIsLightTheme(
        document.documentElement.getAttribute("data-theme") === "light"
      );

    // watch for changes to data-theme on <html>
    const observer = new MutationObserver((mutations) => {
      for (let m of mutations) {
        if (m.attributeName === "data-theme") {
          checkTheme();
        }
      }
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    // cleanup
    return () => observer.disconnect();
  }, []);

  // Determine which logo to display based on the theme
  const logoToUse = isLightTheme ? logoWhite : logo;

  let levelText = "";
  if (level === 1) levelText = "Basics";
  if (level === 2) levelText = "Next Steps";
  if (level === 3) levelText = "Intermediate";
  if (level === 4) levelText = "Advanced";

  return (
    <section className="guide-hero">
      <div className="hero-inner">
        <img src={logoToUse} alt="Matched Edge logo" />
        <h1>{title}</h1>
        <h3>
          Level: {levelText}
        </h3>
      </div>
      <div className="rocket-background">
        {icon}
      </div>
    </section>
  );
};

export default GuideHero;
